import React from 'react';
import './Toast.css';

const Toast = ({ show, message, onClose }) => {
    if (!show) return null;

    return (
        <div className={`toast ${show ? 'show' : ''}`}>
            {message}
        </div>
    );
};

export default Toast;